export class LoginFormModel {
    constructor(
        public email: string = '',
        public senha: string = ''
    ){}
}